import { ITheIndexTag } from '@/js/pages/theindex/types'
import type { IRogue } from '@/js/services/RogueTypes'

export async function searchTags(
  rogue: IRogue, search: string, { page = 1 } = {}
): Promise<ITheIndexTag[]> {
  try {
    const fetchUrl = `${rogue.theIndexBaseURL}/theindex/wp-json/wp/v2/tags?search=${search}&per_page=100&page=${page}`
    const posts = await rogue.api.fetch({ url: fetchUrl, cache: { key: `index-tags-${page}`, seconds: 60 * 60 * 24 } })

    if (Array.isArray(posts)) {
      if (posts.length === 100) {
        return posts.concat(await searchTags(rogue, search, { page: page + 1 }))
      }

      return posts
    }
  } catch (e) {
    const error = e as Error
    rogue.log.error(`Error loading The Index search tags: ${search}`, error)
  }

  return []
}
